import React from 'react';
import DatePicker from 'react-datepicker';
import ReactDatePickerInput from './ReactDatePickerInput';

import 'react-datepicker/dist/react-datepicker.css';

const DateRange = ({startDate, setStartDateCall, endDate, setEndDateCall}) => {
    return (
        <div className="container-date-range">
            <div>
                <DatePicker
                    selected={startDate}
                    onChange={setStartDateCall}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    customInput={<ReactDatePickerInput />}
                    dateFormat="dd/MM/yyyy"
                />
            </div>
            <div>
                <DatePicker
                    selected={endDate}
                    onChange={setEndDateCall}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    customInput={<ReactDatePickerInput />}
                    dateFormat="dd/MM/yyyy"
                />
            </div>
        </div>
    );
};

export default DateRange;
